/**
 * @deprecated Use FeedbackAlertType in "@/services/feedback-alerts-service.ts" instead
 * @type {{SUCCESS: number, ERROR: number}}
 */
export const AlertTypeEnum = {
    SUCCESS: 1,
    ERROR: 2,
};
